import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getContentShowListingCounts({ content }: Props): boolean {
  return Boolean(
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    content && content.heroSearch && content.heroSearch.showCounts
  );
}
